Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _FontSize = require("../../styles/STYLES/FontSize");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS,
    viewports = _STYLES$useStyles.viewports,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    container = _STYLES$useStyles.container;
  var orgProgressContainer = Object.assign({}, container, {
    display: 'flex',
    alignItems: 'center'
  });
  var stepCount = Object.assign({
    fontSize: _FontSize.fontSize.xxl
  }, fontBold, {
    color: COLORS.cherry,
    lineHeight: _FontSize.lineHeight.xxl
  });
  var stepsContainer = {
    alignItems: 'center'
  };
  var navContainer = {
    marginBottom: spacing.xxxl
  };
  var stepCountContainer = {
    marginBottom: 0,
    textAlign: 'center'
  };
  var stepHeading = {
    marginBottom: 0,
    textAlign: 'center'
  };
  var totalStepsTextContainer = {
    textAlign: 'center'
  };
  var totalStepsText = Object.assign({
    fontSize: _FontSize.fontSize.normal,
    color: COLORS.aubergine
  }, fontSemiBold);
  var valueBoxContainer = {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  };
  var valueBox = {};
  var progressToggle = {
    marginTop: spacing.l
  };
  var stepsButtonContainer = {
    marginTop: spacing.l
  };
  var achievements = {
    width: '100%',
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  };
  var footprintSection = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: spacing.xxxl
  };
  var mediaObjectContainer = {
    width: '100%',
    alignItems: 'center'
  };
  var footPrintButton = {
    maxWidth: (0, _styles.getREM)(14),
    marginHorizontal: 'auto',
    marginVertical: spacing.l
  };
  var barChartContainer = {
    marginVertical: spacing.m
  };
  if (bp.gt(viewports.mobile_normal)) {
    achievements.flexDirection = 'row';
  }
  if (bp.gt(viewports.mobile_l)) {
    valueBoxContainer.flexDirection = 'row';
    valueBox.maxWidth = (0, _styles.getREM)(11.25);
    valueBox.padding = spacing.l;
    footprintSection.flexDirection = 'row';
    mediaObjectContainer.flex = 1;
    mediaObjectContainer.width = 450;
    mediaObjectContainer.paddingHorizontal = spacing.s;
  }
  var achievementsGroup = {
    marginTop: spacing.xxxl,
    alignItems: 'center'
  };
  var alignCenter = {
    textAlign: 'center'
  };
  var achievementHeader = {
    textAlign: 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    orgProgressContainer: orgProgressContainer,
    stepCount: stepCount,
    stepCountContainer: stepCountContainer,
    stepHeading: stepHeading,
    totalStepsTextContainer: totalStepsTextContainer,
    totalStepsText: totalStepsText,
    valueBoxContainer: valueBoxContainer,
    valueBox: valueBox,
    progressToggle: progressToggle,
    stepsButtonContainer: stepsButtonContainer,
    achievements: achievements,
    footprintSection: footprintSection,
    mediaObjectContainer: mediaObjectContainer,
    footPrintButton: footPrintButton,
    barChartContainer: barChartContainer,
    achievementsGroup: achievementsGroup,
    stepsContainer: stepsContainer,
    navContainer: navContainer,
    alignCenter: alignCenter,
    achievementHeader: achievementHeader
  });
  return {
    styles: styles
  };
};